import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IEnvCropsFailedOrdersContextValue } from './types';

export default createContext<IEnvCropsFailedOrdersContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
